
export default {
  name: 'BaseProfileStreamHeader',
  props: {
    stream: {
      type: Object,
      required: true,
    },
    collections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filterMenu: [],
      isShowAllMenu: false,
    }
  },
  computed: {
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
    auditorium() {
      if (this.stream?.statistics?.viewsCount < 100) {
        return 'менее 100'
      } else {
        return this.stream?.statistics?.viewsCount
      }
    },
  },
  watch: {
    '$route.path'() {
      this.isShowAllMenu = false
    },
  },
  methods: {
    changeStreamCover(cover) {
      this.$emit('change-stream-cover', cover)
    },
    updateStreamAvatar(avatar) {
      this.$emit('change-stream-avatar', avatar)
    },

    formatText(value, titles) {
      const num = isNaN(value)
        ? Number(
            value
              ?.replace('−', '-')
              ?.replace(/^(-)|[.,](?=[^.,]*[.,](?!$))|[,.]+$|[^0-9.,-]+/g, '$1')
          )
        : value

      const number = Math.abs(num)
      return `${
        titles[
          number % 100 > 4 && number % 100 < 20
            ? 2
            : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? number % 10 : 5]
        ]
      }`
    },
  },
}
